import { Module } from 'vuex-smart-module';
import ReturnZipsActions from './actions';
import ReturnZipsGetters from './getters';
import ReturnZipsMutations from './mutations';
import ReturnZipsState from './state';

export default new Module({
  state: ReturnZipsState,
  mutations: ReturnZipsMutations,
  actions: ReturnZipsActions,
  getters: ReturnZipsGetters,
});
